import { FmtpCustomer } from './fmtpCustomer';

export enum UserType {
    INTERNAL = 'internal',
    EXTERNAL = 'external',
}

export type FmtpUserInfo = {
    customerAccessList?: FmtpCustomer[] | null;
    userType?: UserType;
    fullName?: string;
    userId: string;
};
